import { jsx as w, jsxs as pe } from "@emotion/react/jsx-runtime";
import { i as Je, a as St, u as xt, G as At, M as wt, I as Rt, S as Lt } from "./Header-f04c95d4.mjs";
import { H as po } from "./Header-f04c95d4.mjs";
import { Global as Ot } from "@emotion/react";
import { AnalyticsProvider as kt } from "@inflearn/analytics";
import { ThemeProvider as Bt } from "@inflearn/ds-react";
import { useQueryClient as Gt, onlineManager as Ve, notifyManager as Zt, QueryClient as Wt, QueryClientProvider as _t } from "@tanstack/react-query";
import * as o from "react";
import je, { useMemo as Xt, useState as Vt, useEffect as Ke, cloneElement as Nt } from "react";
import { R as Tt, d as Ft, p as Ht, M as $e, r as Mt, H as Qt, s as Dt, t as Pt, v as zt, w as Yt } from "./StickyHeaderSkeleton-a7f027ad.mjs";
import { s as Ut } from "./styleSkeleton-e0e1cdd5.mjs";
import { i as Jt } from "./quicklink-c03b1140.mjs";
import { createInstance as jt, HackleProvider as Kt } from "@hackler/react-sdk";
import { ChannelTalk as $t } from "./Channeltalk-50e589f4.mjs";
import qt from "./MoveTop-6bc6f73b.mjs";
import { A as en } from "./LoginModal-7ed64f8f.mjs";
import tn from "./BottomNavigation-8e36f02f.mjs";
import { SideSheet as nn } from "./SideSheet-2f07f060.mjs";
import "@mantine/hooks";
import "./isNil-f1df0c3e.mjs";
import "react-error-boundary";
import "@inflearn/datasource-rest";
import "react/jsx-runtime";
import "react-hook-form";
import "dayjs";
import "@mantine/core";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/updateLocale";
import "dayjs/plugin/duration";
import "dayjs/plugin/relativeTime";
function D() {
  return D = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D.apply(this, arguments);
}
/**
   * match-sorter-utils
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
const qe = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z"
}, rn = Object.keys(qe).join("|"), on = new RegExp(rn, "g");
function an(e) {
  return e.replace(on, (t) => qe[t]);
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const G = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
function ln(e, t, n) {
  var r;
  if (n = n || {}, n.threshold = (r = n.threshold) != null ? r : G.MATCHES, !n.accessors) {
    const i = Ne(e, t, n);
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: e,
      rank: i,
      accessorIndex: -1,
      accessorThreshold: n.threshold,
      passed: i >= n.threshold
    };
  }
  const a = fn(e, n.accessors), l = {
    rankedValue: e,
    rank: G.NO_MATCH,
    accessorIndex: -1,
    accessorThreshold: n.threshold,
    passed: !1
  };
  for (let i = 0; i < a.length; i++) {
    const s = a[i];
    let u = Ne(s.itemValue, t, n);
    const {
      minRanking: p,
      maxRanking: m,
      threshold: d = n.threshold
    } = s.attributes;
    u < p && u >= G.MATCHES ? u = p : u > m && (u = m), u = Math.min(u, m), u >= d && u > l.rank && (l.rank = u, l.passed = !0, l.accessorIndex = i, l.accessorThreshold = d, l.rankedValue = s.itemValue);
  }
  return l;
}
function Ne(e, t, n) {
  return e = Te(e, n), t = Te(t, n), t.length > e.length ? G.NO_MATCH : e === t ? G.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), t = t.toLowerCase(), e === t ? G.EQUAL : e.startsWith(t) ? G.STARTS_WITH : e.includes(` ${t}`) ? G.WORD_STARTS_WITH : e.includes(t) ? G.CONTAINS : t.length === 1 ? G.NO_MATCH : sn(e).includes(t) ? G.ACRONYM : un(e, t));
}
function sn(e) {
  let t = "";
  return e.split(" ").forEach((r) => {
    r.split("-").forEach((l) => {
      t += l.substr(0, 1);
    });
  }), t;
}
function un(e, t) {
  let n = 0, r = 0;
  function a(u, p, m) {
    for (let d = m, g = p.length; d < g; d++)
      if (p[d] === u)
        return n += 1, d + 1;
    return -1;
  }
  function l(u) {
    const p = 1 / u, m = n / t.length;
    return G.MATCHES + m * p;
  }
  const i = a(t[0], e, 0);
  if (i < 0)
    return G.NO_MATCH;
  r = i;
  for (let u = 1, p = t.length; u < p; u++) {
    const m = t[u];
    if (r = a(m, e, r), !(r > -1))
      return G.NO_MATCH;
  }
  const s = r - i;
  return l(s);
}
function Te(e, t) {
  let {
    keepDiacritics: n
  } = t;
  return e = `${e}`, n || (e = an(e)), e;
}
function cn(e, t) {
  let n = t;
  typeof t == "object" && (n = t.accessor);
  const r = n(e);
  return r == null ? [] : Array.isArray(r) ? r : [String(r)];
}
function fn(e, t) {
  const n = [];
  for (let r = 0, a = t.length; r < a; r++) {
    const l = t[r], i = dn(l), s = cn(e, l);
    for (let u = 0, p = s.length; u < p; u++)
      n.push({
        itemValue: s[u],
        attributes: i
      });
  }
  return n;
}
const Fe = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function dn(e) {
  return typeof e == "function" ? Fe : {
    ...Fe,
    ...e
  };
}
const pn = (e) => {
  try {
    const t = localStorage.getItem(e);
    return typeof t == "string" ? JSON.parse(t) : void 0;
  } catch {
    return;
  }
};
function P(e, t) {
  const [n, r] = o.useState();
  o.useEffect(() => {
    const l = pn(e);
    r(typeof l > "u" || l === null ? typeof t == "function" ? t() : t : l);
  }, [t, e]);
  const a = o.useCallback((l) => {
    r((i) => {
      let s = l;
      typeof l == "function" && (s = l(i));
      try {
        localStorage.setItem(e, JSON.stringify(s));
      } catch {
      }
      return s;
    });
  }, [e]);
  return [n, a];
}
var mn = (
  /** @class */
  function() {
    function e() {
      this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
    }
    return e.prototype.set = function(t, n) {
      this.keyToValue.set(t, n), this.valueToKey.set(n, t);
    }, e.prototype.getByKey = function(t) {
      return this.keyToValue.get(t);
    }, e.prototype.getByValue = function(t) {
      return this.valueToKey.get(t);
    }, e.prototype.clear = function() {
      this.keyToValue.clear(), this.valueToKey.clear();
    }, e;
  }()
), et = (
  /** @class */
  function() {
    function e(t) {
      this.generateIdentifier = t, this.kv = new mn();
    }
    return e.prototype.register = function(t, n) {
      this.kv.getByValue(t) || (n || (n = this.generateIdentifier(t)), this.kv.set(n, t));
    }, e.prototype.clear = function() {
      this.kv.clear();
    }, e.prototype.getIdentifier = function(t) {
      return this.kv.getByValue(t);
    }, e.prototype.getValue = function(t) {
      return this.kv.getByKey(t);
    }, e;
  }()
), gn = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, a) {
      r.__proto__ = a;
    } || function(r, a) {
      for (var l in a)
        Object.prototype.hasOwnProperty.call(a, l) && (r[l] = a[l]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), yn = (
  /** @class */
  function(e) {
    gn(t, e);
    function t() {
      var n = e.call(this, function(r) {
        return r.name;
      }) || this;
      return n.classToAllowedProps = /* @__PURE__ */ new Map(), n;
    }
    return t.prototype.register = function(n, r) {
      typeof r == "object" ? (r.allowProps && this.classToAllowedProps.set(n, r.allowProps), e.prototype.register.call(this, n, r.identifier)) : e.prototype.register.call(this, n, r);
    }, t.prototype.getAllowedProps = function(n) {
      return this.classToAllowedProps.get(n);
    }, t;
  }(et)
), bn = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
};
function vn(e) {
  if ("values" in Object)
    return Object.values(e);
  var t = [];
  for (var n in e)
    e.hasOwnProperty(n) && t.push(e[n]);
  return t;
}
function hn(e, t) {
  var n = vn(e);
  if ("find" in n)
    return n.find(t);
  for (var r = n, a = 0; a < r.length; a++) {
    var l = r[a];
    if (t(l))
      return l;
  }
}
function ee(e, t) {
  Object.entries(e).forEach(function(n) {
    var r = bn(n, 2), a = r[0], l = r[1];
    return t(l, a);
  });
}
function me(e, t) {
  return e.indexOf(t) !== -1;
}
function He(e, t) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    if (t(r))
      return r;
  }
}
var Cn = (
  /** @class */
  function() {
    function e() {
      this.transfomers = {};
    }
    return e.prototype.register = function(t) {
      this.transfomers[t.name] = t;
    }, e.prototype.findApplicable = function(t) {
      return hn(this.transfomers, function(n) {
        return n.isApplicable(t);
      });
    }, e.prototype.findByName = function(t) {
      return this.transfomers[t];
    }, e;
  }()
), En = function(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}, tt = function(e) {
  return typeof e > "u";
}, In = function(e) {
  return e === null;
}, ae = function(e) {
  return typeof e != "object" || e === null || e === Object.prototype ? !1 : Object.getPrototypeOf(e) === null ? !0 : Object.getPrototypeOf(e) === Object.prototype;
}, xe = function(e) {
  return ae(e) && Object.keys(e).length === 0;
}, Y = function(e) {
  return Array.isArray(e);
}, Sn = function(e) {
  return typeof e == "string";
}, xn = function(e) {
  return typeof e == "number" && !isNaN(e);
}, An = function(e) {
  return typeof e == "boolean";
}, wn = function(e) {
  return e instanceof RegExp;
}, ie = function(e) {
  return e instanceof Map;
}, le = function(e) {
  return e instanceof Set;
}, nt = function(e) {
  return En(e) === "Symbol";
}, Rn = function(e) {
  return e instanceof Date && !isNaN(e.valueOf());
}, Ln = function(e) {
  return e instanceof Error;
}, Me = function(e) {
  return typeof e == "number" && isNaN(e);
}, On = function(e) {
  return An(e) || In(e) || tt(e) || xn(e) || Sn(e) || nt(e);
}, kn = function(e) {
  return typeof e == "bigint";
}, Bn = function(e) {
  return e === 1 / 0 || e === -1 / 0;
}, Gn = function(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}, Zn = function(e) {
  return e instanceof URL;
}, rt = function(e) {
  return e.replace(/\./g, "\\.");
}, he = function(e) {
  return e.map(String).map(rt).join(".");
}, oe = function(e) {
  for (var t = [], n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r), l = a === "\\" && e.charAt(r + 1) === ".";
    if (l) {
      n += ".", r++;
      continue;
    }
    var i = a === ".";
    if (i) {
      t.push(n), n = "";
      continue;
    }
    n += a;
  }
  var s = n;
  return t.push(s), t;
}, Ae = globalThis && globalThis.__assign || function() {
  return Ae = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Ae.apply(this, arguments);
}, we = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, Re = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
};
function X(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
var ot = [
  X(tt, "undefined", function() {
    return null;
  }, function() {
  }),
  X(kn, "bigint", function(e) {
    return e.toString();
  }, function(e) {
    return typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e);
  }),
  X(Rn, "Date", function(e) {
    return e.toISOString();
  }, function(e) {
    return new Date(e);
  }),
  X(Ln, "Error", function(e, t) {
    var n = {
      name: e.name,
      message: e.message
    };
    return t.allowedErrorProps.forEach(function(r) {
      n[r] = e[r];
    }), n;
  }, function(e, t) {
    var n = new Error(e.message);
    return n.name = e.name, n.stack = e.stack, t.allowedErrorProps.forEach(function(r) {
      n[r] = e[r];
    }), n;
  }),
  X(wn, "regexp", function(e) {
    return "" + e;
  }, function(e) {
    var t = e.slice(1, e.lastIndexOf("/")), n = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, n);
  }),
  X(
    le,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(e) {
      return Re([], we(e.values()));
    },
    function(e) {
      return new Set(e);
    }
  ),
  X(ie, "map", function(e) {
    return Re([], we(e.entries()));
  }, function(e) {
    return new Map(e);
  }),
  X(function(e) {
    return Me(e) || Bn(e);
  }, "number", function(e) {
    return Me(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity";
  }, Number),
  X(function(e) {
    return e === 0 && 1 / e === -1 / 0;
  }, "number", function() {
    return "-0";
  }, Number),
  X(Zn, "URL", function(e) {
    return e.toString();
  }, function(e) {
    return new URL(e);
  })
];
function ye(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
var at = ye(function(e, t) {
  if (nt(e)) {
    var n = !!t.symbolRegistry.getIdentifier(e);
    return n;
  }
  return !1;
}, function(e, t) {
  var n = t.symbolRegistry.getIdentifier(e);
  return ["symbol", n];
}, function(e) {
  return e.description;
}, function(e, t, n) {
  var r = n.symbolRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown symbol");
  return r;
}), Wn = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce(function(e, t) {
  return e[t.name] = t, e;
}, {}), it = ye(Gn, function(e) {
  return ["typed-array", e.constructor.name];
}, function(e) {
  return Re([], we(e));
}, function(e, t) {
  var n = Wn[t[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(e);
});
function lt(e, t) {
  if (e != null && e.constructor) {
    var n = !!t.classRegistry.getIdentifier(e.constructor);
    return n;
  }
  return !1;
}
var st = ye(lt, function(e, t) {
  var n = t.classRegistry.getIdentifier(e.constructor);
  return ["class", n];
}, function(e, t) {
  var n = t.classRegistry.getAllowedProps(e.constructor);
  if (!n)
    return Ae({}, e);
  var r = {};
  return n.forEach(function(a) {
    r[a] = e[a];
  }), r;
}, function(e, t, n) {
  var r = n.classRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
  return Object.assign(Object.create(r.prototype), e);
}), ut = ye(function(e, t) {
  return !!t.customTransformerRegistry.findApplicable(e);
}, function(e, t) {
  var n = t.customTransformerRegistry.findApplicable(e);
  return ["custom", n.name];
}, function(e, t) {
  var n = t.customTransformerRegistry.findApplicable(e);
  return n.serialize(e);
}, function(e, t, n) {
  var r = n.customTransformerRegistry.findByName(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown custom value");
  return r.deserialize(e);
}), _n = [st, at, ut, it], Qe = function(e, t) {
  var n = He(_n, function(a) {
    return a.isApplicable(e, t);
  });
  if (n)
    return {
      value: n.transform(e, t),
      type: n.annotation(e, t)
    };
  var r = He(ot, function(a) {
    return a.isApplicable(e, t);
  });
  if (r)
    return {
      value: r.transform(e, t),
      type: r.annotation
    };
}, ct = {};
ot.forEach(function(e) {
  ct[e.annotation] = e;
});
var Xn = function(e, t, n) {
  if (Y(t))
    switch (t[0]) {
      case "symbol":
        return at.untransform(e, t, n);
      case "class":
        return st.untransform(e, t, n);
      case "custom":
        return ut.untransform(e, t, n);
      case "typed-array":
        return it.untransform(e, t, n);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    var r = ct[t];
    if (!r)
      throw new Error("Unknown transformation: " + t);
    return r.untransform(e, n);
  }
}, q = function(e, t) {
  for (var n = e.keys(); t > 0; )
    n.next(), t--;
  return n.next().value;
};
function ft(e) {
  if (me(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (me(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (me(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var Vn = function(e, t) {
  ft(t);
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    if (le(e))
      e = q(e, +r);
    else if (ie(e)) {
      var a = +r, l = +t[++n] == 0 ? "key" : "value", i = q(e, a);
      switch (l) {
        case "key":
          e = i;
          break;
        case "value":
          e = e.get(i);
          break;
      }
    } else
      e = e[r];
  }
  return e;
}, Le = function(e, t, n) {
  if (ft(t), t.length === 0)
    return n(e);
  for (var r = e, a = 0; a < t.length - 1; a++) {
    var l = t[a];
    if (Y(r)) {
      var i = +l;
      r = r[i];
    } else if (ae(r))
      r = r[l];
    else if (le(r)) {
      var s = +l;
      r = q(r, s);
    } else if (ie(r)) {
      var u = a === t.length - 2;
      if (u)
        break;
      var s = +l, p = +t[++a] == 0 ? "key" : "value", m = q(r, s);
      switch (p) {
        case "key":
          r = m;
          break;
        case "value":
          r = r.get(m);
          break;
      }
    }
  }
  var d = t[t.length - 1];
  if (Y(r) ? r[+d] = n(r[+d]) : ae(r) && (r[d] = n(r[d])), le(r)) {
    var g = q(r, +d), c = n(g);
    g !== c && (r.delete(g), r.add(c));
  }
  if (ie(r)) {
    var s = +t[t.length - 2], f = q(r, s), p = +d == 0 ? "key" : "value";
    switch (p) {
      case "key": {
        var y = n(f);
        r.set(y, r.get(f)), y !== f && r.delete(f);
        break;
      }
      case "value": {
        r.set(f, n(r.get(f)));
        break;
      }
    }
  }
  return e;
}, M = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, z = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
};
function Oe(e, t, n) {
  if (n === void 0 && (n = []), !!e) {
    if (!Y(e)) {
      ee(e, function(i, s) {
        return Oe(i, t, z(z([], M(n)), M(oe(s))));
      });
      return;
    }
    var r = M(e, 2), a = r[0], l = r[1];
    l && ee(l, function(i, s) {
      Oe(i, t, z(z([], M(n)), M(oe(s))));
    }), t(a, n);
  }
}
function Nn(e, t, n) {
  return Oe(t, function(r, a) {
    e = Le(e, a, function(l) {
      return Xn(l, r, n);
    });
  }), e;
}
function Tn(e, t) {
  function n(i, s) {
    var u = Vn(e, oe(s));
    i.map(oe).forEach(function(p) {
      e = Le(e, p, function() {
        return u;
      });
    });
  }
  if (Y(t)) {
    var r = M(t, 2), a = r[0], l = r[1];
    a.forEach(function(i) {
      e = Le(e, oe(i), function() {
        return e;
      });
    }), l && ee(l, n);
  } else
    ee(t, n);
  return e;
}
var Fn = function(e, t) {
  return ae(e) || Y(e) || ie(e) || le(e) || lt(e, t);
};
function Hn(e, t, n) {
  var r = n.get(e);
  r ? r.push(t) : n.set(e, [t]);
}
function Mn(e, t) {
  var n = {}, r = void 0;
  return e.forEach(function(a) {
    if (!(a.length <= 1)) {
      t || (a = a.map(function(u) {
        return u.map(String);
      }).sort(function(u, p) {
        return u.length - p.length;
      }));
      var l = M(a), i = l[0], s = l.slice(1);
      i.length === 0 ? r = s.map(he) : n[he(i)] = s.map(he);
    }
  }), r ? xe(n) ? [r] : [r, n] : xe(n) ? void 0 : n;
}
var dt = function(e, t, n, r, a, l, i) {
  var s;
  a === void 0 && (a = []), l === void 0 && (l = []), i === void 0 && (i = /* @__PURE__ */ new Map());
  var u = On(e);
  if (!u) {
    Hn(e, a, t);
    var p = i.get(e);
    if (p)
      return r ? {
        transformedValue: null
      } : p;
  }
  if (!Fn(e, n)) {
    var m = Qe(e, n), d = m ? {
      transformedValue: m.value,
      annotations: [m.type]
    } : {
      transformedValue: e
    };
    return u || i.set(e, d), d;
  }
  if (me(l, e))
    return {
      transformedValue: null
    };
  var g = Qe(e, n), c = (s = g == null ? void 0 : g.value) !== null && s !== void 0 ? s : e, f = Y(c) ? [] : {}, y = {};
  ee(c, function(R, x) {
    var h = dt(R, t, n, r, z(z([], M(a)), [x]), z(z([], M(l)), [e]), i);
    f[x] = h.transformedValue, Y(h.annotations) ? y[x] = h.annotations : ae(h.annotations) && ee(h.annotations, function(b, A) {
      y[rt(x) + "." + A] = b;
    });
  });
  var E = xe(y) ? {
    transformedValue: f,
    annotations: g ? [g.type] : void 0
  } : {
    transformedValue: f,
    annotations: g ? [g.type, y] : y
  };
  return u || i.set(e, E), E;
};
function pt(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function De(e) {
  return pt(e) === "Array";
}
function Qn(e) {
  if (pt(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return !!t && t.constructor === Object && t === Object.prototype;
}
function Dn(e, t, n, r, a) {
  const l = {}.propertyIsEnumerable.call(r, t) ? "enumerable" : "nonenumerable";
  l === "enumerable" && (e[t] = n), a && l === "nonenumerable" && Object.defineProperty(e, t, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function ke(e, t = {}) {
  if (De(e))
    return e.map((a) => ke(a, t));
  if (!Qn(e))
    return e;
  const n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertySymbols(e);
  return [...n, ...r].reduce((a, l) => {
    if (De(t.props) && !t.props.includes(l))
      return a;
    const i = e[l], s = ke(i, t);
    return Dn(a, l, s, e, t.nonenumerable), a;
  }, {});
}
var J = globalThis && globalThis.__assign || function() {
  return J = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, J.apply(this, arguments);
}, Pn = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, zn = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
}, N = (
  /** @class */
  function() {
    function e(t) {
      var n = t === void 0 ? {} : t, r = n.dedupe, a = r === void 0 ? !1 : r;
      this.classRegistry = new yn(), this.symbolRegistry = new et(function(l) {
        var i;
        return (i = l.description) !== null && i !== void 0 ? i : "";
      }), this.customTransformerRegistry = new Cn(), this.allowedErrorProps = [], this.dedupe = a;
    }
    return e.prototype.serialize = function(t) {
      var n = /* @__PURE__ */ new Map(), r = dt(t, n, this, this.dedupe), a = {
        json: r.transformedValue
      };
      r.annotations && (a.meta = J(J({}, a.meta), { values: r.annotations }));
      var l = Mn(n, this.dedupe);
      return l && (a.meta = J(J({}, a.meta), { referentialEqualities: l })), a;
    }, e.prototype.deserialize = function(t) {
      var n = t.json, r = t.meta, a = ke(n);
      return r != null && r.values && (a = Nn(a, r.values, this)), r != null && r.referentialEqualities && (a = Tn(a, r.referentialEqualities)), a;
    }, e.prototype.stringify = function(t) {
      return JSON.stringify(this.serialize(t));
    }, e.prototype.parse = function(t) {
      return this.deserialize(JSON.parse(t));
    }, e.prototype.registerClass = function(t, n) {
      this.classRegistry.register(t, n);
    }, e.prototype.registerSymbol = function(t, n) {
      this.symbolRegistry.register(t, n);
    }, e.prototype.registerCustom = function(t, n) {
      this.customTransformerRegistry.register(J({ name: n }, t));
    }, e.prototype.allowErrorProps = function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      (t = this.allowedErrorProps).push.apply(t, zn([], Pn(n)));
    }, e.defaultInstance = new e(), e.serialize = e.defaultInstance.serialize.bind(e.defaultInstance), e.deserialize = e.defaultInstance.deserialize.bind(e.defaultInstance), e.stringify = e.defaultInstance.stringify.bind(e.defaultInstance), e.parse = e.defaultInstance.parse.bind(e.defaultInstance), e.registerClass = e.defaultInstance.registerClass.bind(e.defaultInstance), e.registerSymbol = e.defaultInstance.registerSymbol.bind(e.defaultInstance), e.registerCustom = e.defaultInstance.registerCustom.bind(e.defaultInstance), e.allowErrorProps = e.defaultInstance.allowErrorProps.bind(e.defaultInstance), e;
  }()
);
N.serialize;
N.deserialize;
N.stringify;
N.parse;
N.registerClass;
N.registerCustom;
N.registerSymbol;
N.allowErrorProps;
const v = {
  background: "#0b1521",
  backgroundAlt: "#132337",
  foreground: "white",
  gray: "#3f4e60",
  grayAlt: "#222e3e",
  inputBackgroundColor: "#fff",
  inputTextColor: "#000",
  success: "#00ab52",
  danger: "#ff0085",
  active: "#006bff",
  paused: "#8c49eb",
  warning: "#ffb200"
}, mt = /* @__PURE__ */ o.createContext(v);
function gt({
  theme: e,
  ...t
}) {
  return /* @__PURE__ */ o.createElement(mt.Provider, D({
    value: e
  }, t));
}
function Yn() {
  return o.useContext(mt);
}
function Un(e) {
  const [t, n] = o.useState(() => {
    if (typeof window < "u")
      return window.matchMedia(e).matches;
  });
  return o.useEffect(() => {
    if (typeof window < "u") {
      const r = window.matchMedia(e), a = ({
        matches: l
      }) => n(l);
      return r.addListener(a), () => {
        r.removeListener(a);
      };
    }
  }, [t, e, n]), t;
}
function yt({
  queryState: e,
  observerCount: t,
  isStale: n,
  theme: r
}) {
  return e.fetchStatus === "fetching" ? r.active : t ? e.fetchStatus === "paused" ? r.paused : n ? r.warning : r.success : r.gray;
}
function $(e) {
  return e.state.fetchStatus === "fetching" ? "fetching" : e.getObserversCount() ? e.state.fetchStatus === "paused" ? "paused" : e.isStale() ? "stale" : "fresh" : "inactive";
}
function B(e, t, n = {}) {
  return /* @__PURE__ */ o.forwardRef(({
    style: r,
    ...a
  }, l) => {
    const i = Yn(), s = Object.entries(n).reduce((u, [p, m]) => Un(p) ? {
      ...u,
      ...typeof m == "function" ? m(a, i) : m
    } : u, {});
    return /* @__PURE__ */ o.createElement(e, {
      ...a,
      style: {
        ...typeof t == "function" ? t(a, i) : t,
        ...r,
        ...s
      },
      ref: l
    });
  });
}
function Jn() {
  const e = o.useRef(!1), t = o.useCallback(() => e.current, []);
  return o.useEffect(() => (e.current = !0, () => {
    e.current = !1;
  }), []), t;
}
const bt = (e, t = !1) => {
  const {
    json: n
  } = N.serialize(e);
  return JSON.stringify(n, null, t ? 2 : void 0);
}, de = (e) => e.state.fetchStatus !== "idle" ? 0 : e.getObserversCount() ? e.isStale() ? 2 : 1 : 3, jn = (e, t) => e.queryHash.localeCompare(t.queryHash), vt = (e, t) => e.state.dataUpdatedAt < t.state.dataUpdatedAt ? 1 : -1, Kn = (e, t) => de(e) === de(t) ? vt(e, t) : de(e) > de(t) ? 1 : -1, Ce = {
  "Status > Last Updated": Kn,
  "Query Hash": jn,
  "Last Updated": vt
}, Be = 70, se = 500, $n = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function ge(e) {
  return ["left", "right"].includes(e);
}
function ht(e) {
  return $n[e];
}
function Xe(e, t) {
  return "" + e + (t.charAt(0).toUpperCase() + t.slice(1));
}
function qn({
  position: e = "bottom",
  height: t,
  width: n,
  devtoolsTheme: r,
  isOpen: a,
  isResizing: l,
  panelStyle: i
}) {
  const s = ht(e), u = Xe("border", s), p = ge(e);
  return {
    ...i,
    direction: "ltr",
    position: "fixed",
    [e]: 0,
    [u]: "1px solid " + r.gray,
    transformOrigin: s,
    boxShadow: "0 0 20px rgba(0,0,0,.3)",
    zIndex: 99999,
    // visibility will be toggled after transitions, but set initial state here
    visibility: a ? "visible" : "hidden",
    ...l ? {
      transition: "none"
    } : {
      transition: "all .2s ease"
    },
    ...a ? {
      opacity: 1,
      pointerEvents: "all",
      transform: p ? "translateX(0) scale(1)" : "translateY(0) scale(1)"
    } : {
      opacity: 0,
      pointerEvents: "none",
      transform: p ? "translateX(15px) scale(1.02)" : "translateY(15px) scale(1.02)"
    },
    ...p ? {
      top: 0,
      height: "100vh",
      maxWidth: "90%",
      width: typeof n == "number" && n >= Be ? n : se
    } : {
      left: 0,
      width: "100%",
      maxHeight: "90%",
      height: typeof t == "number" && t >= Be ? t : se
    }
  };
}
function er(e = "bottom") {
  const t = ge(e), n = ht(e), r = Xe("margin", n);
  return {
    position: "absolute",
    cursor: t ? "col-resize" : "row-resize",
    zIndex: 1e5,
    [n]: 0,
    [r]: "-4px",
    ...t ? {
      top: 0,
      height: "100%",
      width: "4px"
    } : {
      width: "100%",
      height: "4px"
    }
  };
}
const tr = B("div", (e, t) => ({
  fontSize: "clamp(12px, 1.5vw, 14px)",
  fontFamily: "sans-serif",
  display: "flex",
  backgroundColor: t.background,
  color: t.foreground
}), {
  "(max-width: 700px)": {
    flexDirection: "column"
  },
  "(max-width: 600px)": {
    fontSize: ".9em"
    // flexDirection: 'column',
  }
}), nr = B("div", () => ({
  flex: "1 1 500px",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  height: "100%"
}), {
  "(max-width: 700px)": (e, t) => ({
    borderTop: "2px solid " + t.gray
  })
}), V = B("button", (e, t) => ({
  appearance: "none",
  fontSize: ".9em",
  fontWeight: "bold",
  background: t.gray,
  border: "0",
  borderRadius: ".3em",
  color: "white",
  padding: ".5em",
  opacity: e.disabled ? ".5" : void 0,
  cursor: "pointer"
})), rr = B("span", {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5em",
  fontSize: "0.9em"
}), re = B("span", {
  display: "inline-flex",
  alignItems: "center",
  padding: ".2em .4em",
  fontWeight: "bold",
  textShadow: "0 0 10px black",
  borderRadius: ".2em"
}), Q = B("code", {
  fontSize: ".9em",
  color: "inherit",
  background: "inherit"
}), or = B("input", (e, t) => ({
  backgroundColor: t.inputBackgroundColor,
  border: 0,
  borderRadius: ".2em",
  color: t.inputTextColor,
  fontSize: ".9em",
  lineHeight: "1.3",
  padding: ".3em .4em"
})), Ge = B("select", (e, t) => ({
  display: "inline-block",
  fontSize: ".9em",
  fontFamily: "sans-serif",
  fontWeight: "normal",
  lineHeight: "1.3",
  padding: ".3em 1.5em .3em .5em",
  height: "auto",
  border: 0,
  borderRadius: ".2em",
  appearance: "none",
  WebkitAppearance: "none",
  backgroundColor: t.inputBackgroundColor,
  backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23444444'><polygon points='0,25 100,25 50,75'/></svg>")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right .55em center",
  backgroundSize: ".65em auto, 100%",
  color: t.inputTextColor
}), {
  "(max-width: 500px)": {
    display: "none"
  }
});
function Ze({
  text: e
}) {
  return /* @__PURE__ */ o.createElement("span", {
    style: {
      position: "absolute",
      width: "0.1px",
      height: "0.1px",
      overflow: "hidden"
    }
  }, e);
}
const Pe = B("div", {
  fontFamily: "Menlo, monospace",
  fontSize: "1em",
  lineHeight: "1.7",
  outline: "none",
  wordBreak: "break-word"
}), ar = B("span", {
  color: "white"
}), ir = B("button", {
  cursor: "pointer",
  color: "white"
}), lr = B("button", {
  cursor: "pointer",
  color: "inherit",
  font: "inherit",
  outline: "inherit",
  background: "transparent",
  border: "none",
  padding: 0
}), sr = ({
  value: e
}) => {
  const [t, n] = o.useState("NoCopy");
  return /* @__PURE__ */ o.createElement("button", {
    onClick: t === "NoCopy" ? () => {
      navigator.clipboard.writeText(N.stringify(e)).then(() => {
        n("SuccessCopy"), setTimeout(() => {
          n("NoCopy");
        }, 1500);
      }, (r) => {
        console.error("Failed to copy: ", r), n("ErrorCopy"), setTimeout(() => {
          n("NoCopy");
        }, 1500);
      });
    } : void 0,
    style: {
      cursor: "pointer",
      color: "inherit",
      font: "inherit",
      outline: "inherit",
      background: "transparent",
      border: "none",
      padding: 0
    }
  }, t === "NoCopy" ? /* @__PURE__ */ o.createElement(fr, null) : t === "SuccessCopy" ? /* @__PURE__ */ o.createElement(pr, null) : /* @__PURE__ */ o.createElement(dr, null));
}, ur = B("span", (e, t) => ({
  color: t.danger
})), Ee = B("div", {
  marginLeft: ".1em",
  paddingLeft: "1em",
  borderLeft: "2px solid rgba(0,0,0,.15)"
}), cr = B("span", {
  color: "grey",
  fontSize: ".7em"
}), ze = ({
  expanded: e,
  style: t = {}
}) => /* @__PURE__ */ o.createElement("span", {
  style: {
    display: "inline-block",
    transition: "all .1s ease",
    transform: "rotate(" + (e ? 90 : 0) + "deg) " + (t.transform || ""),
    ...t
  }
}, "▶"), fr = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Copy object to clipboard",
  title: "Copy object to clipboard",
  style: {
    paddingLeft: "1em"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "12",
  viewBox: "0 0 16 12",
  width: "10"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "currentColor",
  d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"
}), /* @__PURE__ */ o.createElement("path", {
  fill: "currentColor",
  d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"
}))), dr = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Failed copying to clipboard",
  title: "Failed copying to clipboard",
  style: {
    paddingLeft: "1em",
    display: "flex",
    alignItems: "center"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "12",
  viewBox: "0 0 16 12",
  width: "10",
  display: "block"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "red",
  d: "M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"
})), /* @__PURE__ */ o.createElement("span", {
  style: {
    color: "red",
    fontSize: "12px",
    paddingLeft: "4px",
    position: "relative",
    top: "2px"
  }
}, "See console")), pr = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Object copied to clipboard",
  title: "Object copied to clipboard",
  style: {
    paddingLeft: "1em",
    display: "inline-block",
    verticalAlign: "middle"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  display: "block"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "green",
  d: "M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"
})));
function mr(e, t) {
  if (t < 1)
    return [];
  let n = 0;
  const r = [];
  for (; n < e.length; )
    r.push(e.slice(n, n + t)), n = n + t;
  return r;
}
const gr = ({
  handleEntry: e,
  label: t,
  value: n,
  subEntries: r = [],
  subEntryPages: a = [],
  type: l,
  expanded: i = !1,
  copyable: s = !1,
  toggleExpanded: u,
  pageSize: p
}) => {
  const [m, d] = o.useState([]);
  return /* @__PURE__ */ o.createElement(Pe, {
    key: t
  }, a.length ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(lr, {
    onClick: () => u()
  }, /* @__PURE__ */ o.createElement(ze, {
    expanded: i
  }), " ", t, " ", /* @__PURE__ */ o.createElement(cr, null, String(l).toLowerCase() === "iterable" ? "(Iterable) " : "", r.length, " ", r.length > 1 ? "items" : "item")), s ? /* @__PURE__ */ o.createElement(sr, {
    value: n
  }) : null, i ? a.length === 1 ? /* @__PURE__ */ o.createElement(Ee, null, r.map(e)) : /* @__PURE__ */ o.createElement(Ee, null, a.map((g, c) => /* @__PURE__ */ o.createElement("div", {
    key: c
  }, /* @__PURE__ */ o.createElement(Pe, null, /* @__PURE__ */ o.createElement(ir, {
    onClick: () => d((f) => f.includes(c) ? f.filter((y) => y !== c) : [...f, c])
  }, /* @__PURE__ */ o.createElement(ze, {
    expanded: i
  }), " [", c * p, " ...", " ", c * p + p - 1, "]"), m.includes(c) ? /* @__PURE__ */ o.createElement(Ee, null, g.map(e)) : null)))) : null) : /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(ar, null, t, ":"), " ", /* @__PURE__ */ o.createElement(ur, null, bt(n))));
};
function yr(e) {
  return Symbol.iterator in e;
}
function We({
  value: e,
  defaultExpanded: t,
  renderer: n = gr,
  pageSize: r = 100,
  copyable: a = !1,
  ...l
}) {
  const [i, s] = o.useState(!!t), u = o.useCallback(() => s((c) => !c), []);
  let p = typeof e, m = [];
  const d = (c) => {
    const f = t === !0 ? {
      [c.label]: !0
    } : t == null ? void 0 : t[c.label];
    return {
      ...c,
      defaultExpanded: f
    };
  };
  Array.isArray(e) ? (p = "array", m = e.map((c, f) => d({
    label: f.toString(),
    value: c
  }))) : e !== null && typeof e == "object" && yr(e) && typeof e[Symbol.iterator] == "function" ? (p = "Iterable", m = Array.from(e, (c, f) => d({
    label: f.toString(),
    value: c
  }))) : typeof e == "object" && e !== null && (p = "object", m = Object.entries(e).map(([c, f]) => d({
    label: c,
    value: f
  })));
  const g = mr(m, r);
  return n({
    handleEntry: (c) => /* @__PURE__ */ o.createElement(We, D({
      key: c.label,
      value: e,
      renderer: n,
      copyable: a
    }, l, c)),
    type: p,
    subEntries: m,
    subEntryPages: g,
    value: e,
    expanded: i,
    copyable: a,
    toggleExpanded: u,
    pageSize: r,
    ...l
  });
}
function Ct(e) {
  return /* @__PURE__ */ o.createElement("svg", D({
    width: "40px",
    height: "40px",
    viewBox: "0 0 190 190",
    version: "1.1"
  }, e), /* @__PURE__ */ o.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ o.createElement("g", {
    transform: "translate(-33.000000, 0.000000)"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M72.7239712,61.3436237 C69.631224,46.362877 68.9675112,34.8727722 70.9666331,26.5293551 C72.1555965,21.5671678 74.3293088,17.5190846 77.6346064,14.5984631 C81.1241394,11.5150478 85.5360327,10.0020122 90.493257,10.0020122 C98.6712013,10.0020122 107.26826,13.7273214 116.455725,20.8044264 C120.20312,23.6910458 124.092437,27.170411 128.131651,31.2444746 C128.45314,30.8310265 128.816542,30.4410453 129.22143,30.0806152 C140.64098,19.9149716 150.255245,13.5989272 158.478408,11.1636507 C163.367899,9.715636 167.958526,9.57768202 172.138936,10.983031 C176.551631,12.4664684 180.06766,15.5329489 182.548314,19.8281091 C186.642288,26.9166735 187.721918,36.2310983 186.195595,47.7320243 C185.573451,52.4199112 184.50985,57.5263831 183.007094,63.0593153 C183.574045,63.1277086 184.142416,63.2532808 184.705041,63.4395297 C199.193932,68.2358678 209.453582,73.3937462 215.665021,79.2882839 C219.360669,82.7953831 221.773972,86.6998434 222.646365,91.0218204 C223.567176,95.5836746 222.669313,100.159332 220.191548,104.451297 C216.105211,111.529614 208.591643,117.11221 197.887587,121.534031 C193.589552,123.309539 188.726579,124.917559 183.293259,126.363748 C183.541176,126.92292 183.733521,127.516759 183.862138,128.139758 C186.954886,143.120505 187.618598,154.61061 185.619477,162.954027 C184.430513,167.916214 182.256801,171.964297 178.951503,174.884919 C175.46197,177.968334 171.050077,179.48137 166.092853,179.48137 C157.914908,179.48137 149.31785,175.756061 140.130385,168.678956 C136.343104,165.761613 132.410866,162.238839 128.325434,158.108619 C127.905075,158.765474 127.388968,159.376011 126.77857,159.919385 C115.35902,170.085028 105.744755,176.401073 97.5215915,178.836349 C92.6321009,180.284364 88.0414736,180.422318 83.8610636,179.016969 C79.4483686,177.533532 75.9323404,174.467051 73.4516862,170.171891 C69.3577116,163.083327 68.2780823,153.768902 69.8044053,142.267976 C70.449038,137.410634 71.56762,132.103898 73.1575891,126.339009 C72.5361041,126.276104 71.9120754,126.144816 71.2949591,125.940529 C56.8060684,121.144191 46.5464184,115.986312 40.3349789,110.091775 C36.6393312,106.584675 34.2260275,102.680215 33.3536352,98.3582381 C32.4328237,93.7963839 33.3306866,89.2207269 35.8084524,84.9287618 C39.8947886,77.8504443 47.4083565,72.2678481 58.1124133,67.8460273 C62.5385143,66.0176154 67.5637208,64.366822 73.1939394,62.8874674 C72.9933393,62.3969171 72.8349374,61.8811235 72.7239712,61.3436237 Z",
    fill: "#002C4B",
    fillRule: "nonzero",
    transform: "translate(128.000000, 95.000000) scale(-1, 1) translate(-128.000000, -95.000000) "
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M113.396882,64 L142.608177,64 C144.399254,64 146.053521,64.958025 146.944933,66.5115174 L161.577138,92.0115174 C162.461464,93.5526583 162.461464,95.4473417 161.577138,96.9884826 L146.944933,122.488483 C146.053521,124.041975 144.399254,125 142.608177,125 L113.396882,125 C111.605806,125 109.951539,124.041975 109.060126,122.488483 L94.4279211,96.9884826 C93.543596,95.4473417 93.543596,93.5526583 94.4279211,92.0115174 L109.060126,66.5115174 C109.951539,64.958025 111.605806,64 113.396882,64 Z M138.987827,70.2765273 C140.779849,70.2765273 142.434839,71.2355558 143.325899,72.7903404 L154.343038,92.0138131 C155.225607,93.5537825 155.225607,95.4462175 154.343038,96.9861869 L143.325899,116.20966 C142.434839,117.764444 140.779849,118.723473 138.987827,118.723473 L117.017233,118.723473 C115.225211,118.723473 113.570221,117.764444 112.67916,116.20966 L101.662022,96.9861869 C100.779452,95.4462175 100.779452,93.5537825 101.662022,92.0138131 L112.67916,72.7903404 C113.570221,71.2355558 115.225211,70.2765273 117.017233,70.2765273 L138.987827,70.2765273 Z M135.080648,77.1414791 L120.924411,77.1414791 C119.134228,77.1414791 117.480644,78.0985567 116.5889,79.6508285 L116.5889,79.6508285 L109.489217,92.0093494 C108.603232,93.5515958 108.603232,95.4484042 109.489217,96.9906506 L109.489217,96.9906506 L116.5889,109.349172 C117.480644,110.901443 119.134228,111.858521 120.924411,111.858521 L120.924411,111.858521 L135.080648,111.858521 C136.870831,111.858521 138.524416,110.901443 139.41616,109.349172 L139.41616,109.349172 L146.515843,96.9906506 C147.401828,95.4484042 147.401828,93.5515958 146.515843,92.0093494 L146.515843,92.0093494 L139.41616,79.6508285 C138.524416,78.0985567 136.870831,77.1414791 135.080648,77.1414791 L135.080648,77.1414791 Z M131.319186,83.7122186 C133.108028,83.7122186 134.760587,84.6678753 135.652827,86.2183156 L138.983552,92.0060969 C139.87203,93.5500005 139.87203,95.4499995 138.983552,96.9939031 L135.652827,102.781684 C134.760587,104.332125 133.108028,105.287781 131.319186,105.287781 L124.685874,105.287781 C122.897032,105.287781 121.244473,104.332125 120.352233,102.781684 L117.021508,96.9939031 C116.13303,95.4499995 116.13303,93.5500005 117.021508,92.0060969 L120.352233,86.2183156 C121.244473,84.6678753 122.897032,83.7122186 124.685874,83.7122186 L131.319186,83.7122186 Z M128.003794,90.1848875 C126.459294,90.1848875 125.034382,91.0072828 124.263005,92.3424437 C123.491732,93.6774232 123.491732,95.3225768 124.263005,96.6575563 C125.034382,97.9927172 126.459294,98.8151125 128.001266,98.8151125 L128.001266,98.8151125 C129.545766,98.8151125 130.970678,97.9927172 131.742055,96.6575563 C132.513327,95.3225768 132.513327,93.6774232 131.742055,92.3424437 C130.970678,91.0072828 129.545766,90.1848875 128.003794,90.1848875 L128.003794,90.1848875 Z M93,94.5009646 L100.767764,94.5009646",
    fill: "#FFD94C"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M87.8601729,108.357758 C89.1715224,107.608286 90.8360246,108.074601 91.5779424,109.399303 L91.5779424,109.399303 L92.0525843,110.24352 C95.8563392,116.982993 99.8190116,123.380176 103.940602,129.435068 C108.807881,136.585427 114.28184,143.82411 120.362479,151.151115 C121.316878,152.30114 121.184944,154.011176 120.065686,154.997937 L120.065686,154.997937 L119.454208,155.534625 C99.3465389,173.103314 86.2778188,176.612552 80.2480482,166.062341 C74.3500652,155.742717 76.4844915,136.982888 86.6513274,109.782853 C86.876818,109.179582 87.3045861,108.675291 87.8601729,108.357758 Z M173.534177,129.041504 C174.986131,128.785177 176.375496,129.742138 176.65963,131.194242 L176.65963,131.194242 L176.812815,131.986376 C181.782365,157.995459 178.283348,171 166.315764,171 C154.609745,171 139.708724,159.909007 121.612702,137.727022 C121.211349,137.235047 120.994572,136.617371 121,135.981509 C121.013158,134.480686 122.235785,133.274651 123.730918,133.287756 L123.730918,133.287756 L124.684654,133.294531 C132.305698,133.335994 139.714387,133.071591 146.910723,132.501323 C155.409039,131.82788 164.283523,130.674607 173.534177,129.041504 Z M180.408726,73.8119663 C180.932139,72.4026903 182.508386,71.6634537 183.954581,72.149012 L183.954581,72.149012 L184.742552,72.4154854 C210.583763,81.217922 220.402356,90.8916805 214.198332,101.436761 C208.129904,111.751366 190.484347,119.260339 161.26166,123.963678 C160.613529,124.067994 159.948643,123.945969 159.382735,123.618843 C158.047025,122.846729 157.602046,121.158214 158.388848,119.847438 L158.388848,119.847438 L158.889328,119.0105 C162.877183,112.31633 166.481358,105.654262 169.701854,99.0242957 C173.50501,91.1948179 177.073967,82.7907081 180.408726,73.8119663 Z M94.7383398,66.0363218 C95.3864708,65.9320063 96.0513565,66.0540315 96.6172646,66.3811573 C97.9529754,67.153271 98.3979538,68.8417862 97.6111517,70.1525615 L97.6111517,70.1525615 L97.1106718,70.9895001 C93.1228168,77.6836699 89.5186416,84.3457379 86.2981462,90.9757043 C82.49499,98.8051821 78.9260328,107.209292 75.5912744,116.188034 C75.0678608,117.59731 73.4916142,118.336546 72.045419,117.850988 L72.045419,117.850988 L71.2574475,117.584515 C45.4162372,108.782078 35.597644,99.1083195 41.8016679,88.5632391 C47.8700957,78.2486335 65.515653,70.7396611 94.7383398,66.0363218 Z M136.545792,34.4653746 C156.653461,16.8966864 169.722181,13.3874478 175.751952,23.9376587 C181.649935,34.2572826 179.515508,53.0171122 169.348673,80.2171474 C169.123182,80.8204179 168.695414,81.324709 168.139827,81.6422422 C166.828478,82.3917144 165.163975,81.9253986 164.422058,80.6006966 L164.422058,80.6006966 L163.947416,79.7564798 C160.143661,73.0170065 156.180988,66.6198239 152.059398,60.564932 C147.192119,53.4145727 141.71816,46.1758903 135.637521,38.8488847 C134.683122,37.6988602 134.815056,35.9888243 135.934314,35.0020629 L135.934314,35.0020629 Z M90.6842361,18 C102.390255,18 117.291276,29.0909926 135.387298,51.2729777 C135.788651,51.7649527 136.005428,52.3826288 136,53.0184911 C135.986842,54.5193144 134.764215,55.7253489 133.269082,55.7122445 L133.269082,55.7122445 L132.315346,55.7054689 C124.694302,55.6640063 117.285613,55.9284091 110.089277,56.4986773 C101.590961,57.17212 92.7164767,58.325393 83.4658235,59.9584962 C82.0138691,60.2148231 80.6245044,59.2578618 80.3403697,57.805758 L80.3403697,57.805758 L80.1871846,57.0136235 C75.2176347,31.0045412 78.7166519,18 90.6842361,18 Z",
    fill: "#FF4154"
  }))));
}
var _e = { exports: {} }, Ie = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ye;
function br() {
  if (Ye)
    return Ie;
  Ye = 1;
  var e = je;
  function t(d, g) {
    return d === g && (d !== 0 || 1 / d === 1 / g) || d !== d && g !== g;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, a = e.useEffect, l = e.useLayoutEffect, i = e.useDebugValue;
  function s(d, g) {
    var c = g(), f = r({ inst: { value: c, getSnapshot: g } }), y = f[0].inst, E = f[1];
    return l(function() {
      y.value = c, y.getSnapshot = g, u(y) && E({ inst: y });
    }, [d, c, g]), a(function() {
      return u(y) && E({ inst: y }), d(function() {
        u(y) && E({ inst: y });
      });
    }, [d]), i(c), c;
  }
  function u(d) {
    var g = d.getSnapshot;
    d = d.value;
    try {
      var c = g();
      return !n(d, c);
    } catch {
      return !0;
    }
  }
  function p(d, g) {
    return g();
  }
  var m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : s;
  return Ie.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : m, Ie;
}
var Se = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ue;
function vr() {
  return Ue || (Ue = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = je, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(h) {
      {
        for (var b = arguments.length, A = new Array(b > 1 ? b - 1 : 0), I = 1; I < b; I++)
          A[I - 1] = arguments[I];
        r("error", h, A);
      }
    }
    function r(h, b, A) {
      {
        var I = t.ReactDebugCurrentFrame, W = I.getStackAddendum();
        W !== "" && (b += "%s", A = A.concat([W]));
        var Z = A.map(function(O) {
          return String(O);
        });
        Z.unshift("Warning: " + b), Function.prototype.apply.call(console[h], console, Z);
      }
    }
    function a(h, b) {
      return h === b && (h !== 0 || 1 / h === 1 / b) || h !== h && b !== b;
    }
    var l = typeof Object.is == "function" ? Object.is : a, i = e.useState, s = e.useEffect, u = e.useLayoutEffect, p = e.useDebugValue, m = !1, d = !1;
    function g(h, b, A) {
      m || e.startTransition !== void 0 && (m = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var I = b();
      if (!d) {
        var W = b();
        l(I, W) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var Z = i({
        inst: {
          value: I,
          getSnapshot: b
        }
      }), O = Z[0].inst, T = Z[1];
      return u(function() {
        O.value = I, O.getSnapshot = b, c(O) && T({
          inst: O
        });
      }, [h, I, b]), s(function() {
        c(O) && T({
          inst: O
        });
        var te = function() {
          c(O) && T({
            inst: O
          });
        };
        return h(te);
      }, [h]), p(I), I;
    }
    function c(h) {
      var b = h.getSnapshot, A = h.value;
      try {
        var I = b();
        return !l(A, I);
      } catch {
        return !0;
      }
    }
    function f(h, b, A) {
      return b();
    }
    var y = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", E = !y, R = E ? f : g, x = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : R;
    Se.useSyncExternalStore = x, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Se;
}
process.env.NODE_ENV === "production" ? _e.exports = br() : _e.exports = vr();
var hr = _e.exports;
function Cr({
  initialIsOpen: e,
  panelProps: t = {},
  closeButtonProps: n = {},
  toggleButtonProps: r = {},
  position: a = "bottom-left",
  containerElement: l = "aside",
  context: i,
  styleNonce: s,
  panelPosition: u = "bottom",
  errorTypes: p = []
}) {
  const m = o.useRef(null), d = o.useRef(null), [g, c] = P("reactQueryDevtoolsOpen", e), [f, y] = P("reactQueryDevtoolsHeight", se), [E, R] = P("reactQueryDevtoolsWidth", se), [x = "bottom", h] = P("reactQueryDevtoolsPanelPosition", u), [b, A] = o.useState(!1), [I, W] = o.useState(!1), Z = Jn(), O = (S, L) => {
    if (!S || L.button !== 0)
      return;
    const _ = ge(x);
    W(!0);
    const {
      height: ne,
      width: ve
    } = S.getBoundingClientRect(), j = L.clientX, K = L.clientY;
    let H = 0;
    const ce = (U) => {
      U.preventDefault(), _ ? (H = ve + (x === "right" ? j - U.clientX : U.clientX - j), R(H)) : (H = ne + (x === "bottom" ? K - U.clientY : U.clientY - K), y(H)), H < Be ? c(!1) : c(!0);
    }, fe = () => {
      I && W(!1), document.removeEventListener("mousemove", ce, !1), document.removeEventListener("mouseUp", fe, !1);
    };
    document.addEventListener("mousemove", ce, !1), document.addEventListener("mouseup", fe, !1);
  };
  o.useEffect(() => {
    A(g ?? !1);
  }, [g, b, A]), o.useEffect(() => {
    const S = d.current;
    if (S) {
      const L = () => {
        b && (S.style.visibility = "visible");
      }, _ = () => {
        b || (S.style.visibility = "hidden");
      };
      return S.addEventListener("transitionstart", L), S.addEventListener("transitionend", _), () => {
        S.removeEventListener("transitionstart", L), S.removeEventListener("transitionend", _);
      };
    }
  }, [b]), o.useEffect(() => {
    var S;
    if (b && (S = m.current) != null && S.parentElement) {
      const {
        parentElement: L
      } = m.current, _ = Xe("padding", x), ne = ge(x), ve = (({
        padding: K,
        paddingTop: H,
        paddingBottom: ce,
        paddingLeft: fe,
        paddingRight: U
      }) => ({
        padding: K,
        paddingTop: H,
        paddingBottom: ce,
        paddingLeft: fe,
        paddingRight: U
      }))(L.style), j = () => {
        L.style.padding = "0px", L.style.paddingTop = "0px", L.style.paddingBottom = "0px", L.style.paddingLeft = "0px", L.style.paddingRight = "0px", L.style[_] = (ne ? E : f) + "px";
      };
      if (j(), typeof window < "u")
        return window.addEventListener("resize", j), () => {
          window.removeEventListener("resize", j), Object.entries(ve).forEach(([K, H]) => {
            L.style[K] = H;
          });
        };
    }
  }, [b, x, f, E]);
  const {
    style: T = {},
    ...te
  } = t, {
    style: be = {},
    onClick: F,
    ...ue
  } = r, C = qn({
    position: x,
    devtoolsTheme: v,
    isOpen: b,
    height: f,
    width: E,
    isResizing: I,
    panelStyle: T
  });
  return Z() ? /* @__PURE__ */ o.createElement(l, {
    ref: m,
    className: "ReactQueryDevtools",
    "aria-label": "React Query Devtools"
  }, /* @__PURE__ */ o.createElement(gt, {
    theme: v
  }, /* @__PURE__ */ o.createElement(Et, D({
    ref: d,
    context: i,
    styleNonce: s,
    position: x,
    onPositionChange: h,
    showCloseButton: !0,
    closeButtonProps: n
  }, te, {
    style: C,
    isOpen: b,
    setIsOpen: c,
    onDragStart: (S) => O(d.current, S),
    errorTypes: p
  }))), b ? null : /* @__PURE__ */ o.createElement("button", D({
    type: "button"
  }, ue, {
    "aria-label": "Open React Query Devtools",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "false",
    onClick: (S) => {
      c(!0), F == null || F(S);
    },
    style: {
      background: "none",
      border: 0,
      padding: 0,
      position: "fixed",
      zIndex: 99999,
      display: "inline-flex",
      fontSize: "1.5em",
      margin: ".5em",
      cursor: "pointer",
      width: "fit-content",
      ...a === "top-right" ? {
        top: "0",
        right: "0"
      } : a === "top-left" ? {
        top: "0",
        left: "0"
      } : a === "bottom-right" ? {
        bottom: "0",
        right: "0"
      } : {
        bottom: "0",
        left: "0"
      },
      ...be
    }
  }), /* @__PURE__ */ o.createElement(Ct, {
    "aria-hidden": !0
  }), /* @__PURE__ */ o.createElement(Ze, {
    text: "Open React Query Devtools"
  }))) : null;
}
const k = (e, t, n = !1) => hr.useSyncExternalStore(o.useCallback((r) => n ? () => {
} : e.subscribe(Zt.batchCalls(r)), [e, n]), t, t), Et = /* @__PURE__ */ o.forwardRef(function(t, n) {
  const {
    isOpen: r = !0,
    styleNonce: a,
    setIsOpen: l,
    context: i,
    onDragStart: s,
    onPositionChange: u,
    showCloseButton: p,
    position: m,
    closeButtonProps: d = {},
    errorTypes: g = [],
    ...c
  } = t, {
    onClick: f,
    ...y
  } = d, E = Gt({
    context: i
  }), R = E.getQueryCache(), [x, h] = P("reactQueryDevtoolsSortFn", Object.keys(Ce)[0]), [b, A] = P("reactQueryDevtoolsFilter", ""), [I, W] = P("reactQueryDevtoolsBaseSort", 1), Z = o.useMemo(() => Ce[x], [x]), O = k(R, () => R.getAll().length, !r), [T, te] = P("reactQueryDevtoolsActiveQueryHash", ""), be = o.useMemo(() => {
    const C = R.getAll();
    if (O === 0)
      return [];
    const S = b ? C.filter((_) => ln(_.queryHash, b).passed) : [...C];
    return Z ? S.sort((_, ne) => Z(_, ne) * I) : S;
  }, [I, Z, b, O, R]), [F, ue] = o.useState(!1);
  return /* @__PURE__ */ o.createElement(gt, {
    theme: v
  }, /* @__PURE__ */ o.createElement(tr, D({
    ref: n,
    className: "ReactQueryDevtoolsPanel",
    "aria-label": "React Query Devtools Panel",
    id: "ReactQueryDevtoolsPanel"
  }, c, {
    style: {
      height: se,
      position: "relative",
      ...c.style
    }
  }), /* @__PURE__ */ o.createElement("style", {
    nonce: a,
    dangerouslySetInnerHTML: {
      __html: `
            .ReactQueryDevtoolsPanel * {
              scrollbar-color: ` + v.backgroundAlt + " " + v.gray + `;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar, .ReactQueryDevtoolsPanel scrollbar {
              width: 1em;
              height: 1em;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-track, .ReactQueryDevtoolsPanel scrollbar-track {
              background: ` + v.backgroundAlt + `;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-thumb, .ReactQueryDevtoolsPanel scrollbar-thumb {
              background: ` + v.gray + `;
              border-radius: .5em;
              border: 3px solid ` + v.backgroundAlt + `;
            }
          `
    }
  }), /* @__PURE__ */ o.createElement("div", {
    style: er(m),
    onMouseDown: s
  }), r && /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "1 1 500px",
      minHeight: "40%",
      maxHeight: "100%",
      overflow: "auto",
      borderRight: "1px solid " + v.grayAlt,
      display: "flex",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em",
      background: v.backgroundAlt,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": "Close React Query Devtools",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "true",
    onClick: () => l(!1),
    style: {
      display: "inline-flex",
      background: "none",
      border: 0,
      padding: 0,
      marginRight: ".5em",
      cursor: "pointer"
    }
  }, /* @__PURE__ */ o.createElement(Ct, {
    "aria-hidden": !0
  }), /* @__PURE__ */ o.createElement(Ze, {
    text: "Close React Query Devtools"
  })), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(Ir, {
    queryCache: R
  }), m && u ? /* @__PURE__ */ o.createElement(Ge, {
    "aria-label": "Panel position",
    value: m,
    style: {
      marginInlineStart: ".5em"
    },
    onChange: (C) => u(C.target.value)
  }, /* @__PURE__ */ o.createElement("option", {
    value: "left"
  }, "Left"), /* @__PURE__ */ o.createElement("option", {
    value: "right"
  }, "Right"), /* @__PURE__ */ o.createElement("option", {
    value: "top"
  }, "Top"), /* @__PURE__ */ o.createElement("option", {
    value: "bottom"
  }, "Bottom")) : null), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "0.5em"
    }
  }, /* @__PURE__ */ o.createElement(or, {
    placeholder: "Filter",
    "aria-label": "Filter by queryhash",
    value: b ?? "",
    onChange: (C) => A(C.target.value),
    onKeyDown: (C) => {
      C.key === "Escape" && A("");
    },
    style: {
      flex: "1",
      width: "100%"
    }
  }), /* @__PURE__ */ o.createElement(Ge, {
    "aria-label": "Sort queries",
    value: x,
    onChange: (C) => h(C.target.value),
    style: {
      flex: "1",
      minWidth: 75,
      marginRight: ".5em"
    }
  }, Object.keys(Ce).map((C) => /* @__PURE__ */ o.createElement("option", {
    key: C,
    value: C
  }, "Sort by ", C))), /* @__PURE__ */ o.createElement(V, {
    type: "button",
    onClick: () => W((C) => C * -1),
    style: {
      padding: ".3em .4em",
      marginRight: ".5em"
    }
  }, I === 1 ? "⬆ Asc" : "⬇ Desc"), /* @__PURE__ */ o.createElement(V, {
    title: "Clear cache",
    "aria-label": "Clear cache",
    type: "button",
    onClick: () => R.clear(),
    style: {
      padding: ".3em .4em",
      marginRight: ".5em"
    }
  }, "Clear"), /* @__PURE__ */ o.createElement(V, {
    type: "button",
    onClick: () => {
      F ? (Ve.setOnline(void 0), ue(!1), window.dispatchEvent(new Event("online"))) : (Ve.setOnline(!1), ue(!0));
    },
    "aria-label": F ? "Restore offline mock" : "Mock offline behavior",
    title: F ? "Restore offline mock" : "Mock offline behavior",
    style: {
      padding: "0",
      height: "2em"
    }
  }, /* @__PURE__ */ o.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2em",
    height: "2em",
    viewBox: "0 0 24 24",
    stroke: F ? v.danger : "currentColor",
    fill: "none"
  }, F ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "3",
    y1: "3",
    x2: "21",
    y2: "21"
  })) : /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
  }))), /* @__PURE__ */ o.createElement(Ze, {
    text: F ? "Restore offline mock" : "Mock offline behavior"
  }))))), /* @__PURE__ */ o.createElement("div", {
    style: {
      overflowY: "auto",
      flex: "1"
    }
  }, be.map((C) => /* @__PURE__ */ o.createElement(It, {
    queryKey: C.queryKey,
    activeQueryHash: T,
    setActiveQueryHash: te,
    key: C.queryHash,
    queryCache: R
  })))), T && r ? /* @__PURE__ */ o.createElement(Er, {
    activeQueryHash: T,
    queryCache: R,
    queryClient: E,
    errorTypes: g
  }) : null, p ? /* @__PURE__ */ o.createElement(V, D({
    type: "button",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "true"
  }, y, {
    style: {
      position: "absolute",
      zIndex: 99999,
      margin: ".5em",
      bottom: 0,
      left: 0,
      ...y.style
    },
    onClick: (C) => {
      l(!1), f == null || f(C);
    }
  }), "Close") : null));
}), Er = ({
  queryCache: e,
  activeQueryHash: t,
  queryClient: n,
  errorTypes: r
}) => {
  var a, l;
  const i = k(e, () => e.getAll().find((f) => f.queryHash === t)), s = k(e, () => {
    var f;
    return (f = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : f.state;
  }), u = (a = k(e, () => {
    var f;
    return (f = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : f.isStale();
  })) != null ? a : !1, p = (l = k(e, () => {
    var f;
    return (f = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : f.getObserversCount();
  })) != null ? l : 0, m = () => {
    const f = i == null ? void 0 : i.fetch();
    f == null || f.catch(Sr);
  }, d = Xt(() => {
    if (i && s != null && s.error) {
      const f = r.find((y) => {
        var E;
        return y.initializer(i).toString() === ((E = s.error) == null ? void 0 : E.toString());
      });
      return f == null ? void 0 : f.name;
    }
  }, [i, s == null ? void 0 : s.error, r]);
  if (!i || !s)
    return null;
  const g = (f) => {
    var y;
    const E = (y = f == null ? void 0 : f.initializer(i)) != null ? y : new Error("Unknown error from devtools"), R = i.options;
    i.setState({
      status: "error",
      error: E,
      fetchMeta: {
        ...i.state.fetchMeta,
        __previousQueryOptions: R
      }
    });
  }, c = () => {
    i.fetch(i.state.fetchMeta.__previousQueryOptions, {
      // Make sure this fetch will cancel the previous one
      cancelRefetch: !0
    });
  };
  return /* @__PURE__ */ o.createElement(nr, null, /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em",
      background: v.backgroundAlt,
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Query Details"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      marginBottom: ".5em",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between"
    }
  }, /* @__PURE__ */ o.createElement(Q, {
    style: {
      lineHeight: "1.8em"
    }
  }, /* @__PURE__ */ o.createElement("pre", {
    style: {
      margin: 0,
      padding: 0,
      overflow: "auto"
    }
  }, bt(i.queryKey, !0))), /* @__PURE__ */ o.createElement("span", {
    style: {
      padding: "0.3em .6em",
      borderRadius: "0.4em",
      fontWeight: "bold",
      textShadow: "0 2px 10px black",
      background: yt({
        queryState: s,
        isStale: u,
        observerCount: p,
        theme: v
      }),
      flexShrink: 0
    }
  }, $(i))), /* @__PURE__ */ o.createElement("div", {
    style: {
      marginBottom: ".5em",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, "Observers: ", /* @__PURE__ */ o.createElement(Q, null, p)), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, "Last Updated:", " ", /* @__PURE__ */ o.createElement(Q, null, new Date(s.dataUpdatedAt).toLocaleTimeString()))), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: v.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Actions"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: "0.5em",
      display: "flex",
      flexWrap: "wrap",
      gap: "0.5em",
      alignItems: "flex-end"
    }
  }, /* @__PURE__ */ o.createElement(V, {
    type: "button",
    onClick: m,
    disabled: s.fetchStatus === "fetching",
    style: {
      background: v.active
    }
  }, "Refetch"), " ", /* @__PURE__ */ o.createElement(V, {
    type: "button",
    onClick: () => n.invalidateQueries(i),
    style: {
      background: v.warning,
      color: v.inputTextColor
    }
  }, "Invalidate"), " ", /* @__PURE__ */ o.createElement(V, {
    type: "button",
    onClick: () => n.resetQueries(i),
    style: {
      background: v.gray
    }
  }, "Reset"), " ", /* @__PURE__ */ o.createElement(V, {
    type: "button",
    onClick: () => n.removeQueries(i),
    style: {
      background: v.danger
    }
  }, "Remove"), " ", /* @__PURE__ */ o.createElement(V, {
    type: "button",
    onClick: () => {
      var f;
      if (!(i.state.fetchStatus === "fetching" && typeof ((f = i.state.fetchMeta) == null ? void 0 : f.__previousQueryOptions) > "u"))
        if (i.state.data === void 0)
          c();
        else {
          const y = i.options;
          i.fetch({
            ...y,
            queryFn: () => new Promise(() => {
            }),
            cacheTime: -1
          }), i.setState({
            data: void 0,
            status: "loading",
            fetchMeta: {
              ...i.state.fetchMeta,
              __previousQueryOptions: y
            }
          });
        }
    },
    style: {
      background: v.paused
    }
  }, i.state.status === "loading" ? "Restore" : "Trigger", " ", "loading"), " ", r.length === 0 || i.state.status === "error" ? /* @__PURE__ */ o.createElement(V, {
    type: "button",
    onClick: () => {
      i.state.error ? n.resetQueries(i) : g();
    },
    style: {
      background: v.danger
    }
  }, i.state.status === "error" ? "Restore" : "Trigger", " error") : /* @__PURE__ */ o.createElement("label", null, "Trigger error:", /* @__PURE__ */ o.createElement(Ge, {
    value: d ?? "",
    style: {
      marginInlineStart: ".5em"
    },
    onChange: (f) => {
      const y = r.find((E) => E.name === f.target.value);
      g(y);
    }
  }, /* @__PURE__ */ o.createElement("option", {
    key: "",
    value: ""
  }), r.map((f) => /* @__PURE__ */ o.createElement("option", {
    key: f.name,
    value: f.name
  }, f.name))))), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: v.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Data Explorer"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(We, {
    label: "Data",
    value: s.data,
    defaultExpanded: {},
    copyable: !0
  })), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: v.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Query Explorer"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(We, {
    label: "Query",
    value: i,
    defaultExpanded: {
      queryKey: !0
    }
  })));
}, Ir = ({
  queryCache: e
}) => {
  const t = k(e, () => e.getAll().filter((i) => $(i) === "fresh").length), n = k(e, () => e.getAll().filter((i) => $(i) === "fetching").length), r = k(e, () => e.getAll().filter((i) => $(i) === "paused").length), a = k(e, () => e.getAll().filter((i) => $(i) === "stale").length), l = k(e, () => e.getAll().filter((i) => $(i) === "inactive").length);
  return /* @__PURE__ */ o.createElement(rr, null, /* @__PURE__ */ o.createElement(re, {
    style: {
      background: v.success,
      opacity: t ? 1 : 0.3
    }
  }, "fresh ", /* @__PURE__ */ o.createElement(Q, null, "(", t, ")")), " ", /* @__PURE__ */ o.createElement(re, {
    style: {
      background: v.active,
      opacity: n ? 1 : 0.3
    }
  }, "fetching ", /* @__PURE__ */ o.createElement(Q, null, "(", n, ")")), " ", /* @__PURE__ */ o.createElement(re, {
    style: {
      background: v.paused,
      opacity: r ? 1 : 0.3
    }
  }, "paused ", /* @__PURE__ */ o.createElement(Q, null, "(", r, ")")), " ", /* @__PURE__ */ o.createElement(re, {
    style: {
      background: v.warning,
      color: "black",
      textShadow: "0",
      opacity: a ? 1 : 0.3
    }
  }, "stale ", /* @__PURE__ */ o.createElement(Q, null, "(", a, ")")), " ", /* @__PURE__ */ o.createElement(re, {
    style: {
      background: v.gray,
      opacity: l ? 1 : 0.3
    }
  }, "inactive ", /* @__PURE__ */ o.createElement(Q, null, "(", l, ")")));
}, It = /* @__PURE__ */ o.memo(({
  queryKey: e,
  setActiveQueryHash: t,
  activeQueryHash: n,
  queryCache: r
}) => {
  var a, l, i, s;
  const u = (a = k(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.queryHash;
  })) != null ? a : "", p = k(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.state;
  }), m = (l = k(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.isStale();
  })) != null ? l : !1, d = (i = k(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.isDisabled();
  })) != null ? i : !1, g = (s = k(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.getObserversCount();
  })) != null ? s : 0;
  return p ? /* @__PURE__ */ o.createElement("div", {
    role: "button",
    "aria-label": "Open query details for " + u,
    onClick: () => t(n === u ? "" : u),
    style: {
      display: "flex",
      borderBottom: "solid 1px " + v.grayAlt,
      cursor: "pointer",
      background: u === n ? "rgba(255,255,255,.1)" : void 0
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "0 0 auto",
      width: "2em",
      height: "2em",
      background: yt({
        queryState: p,
        isStale: m,
        observerCount: g,
        theme: v
      }),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      textShadow: m ? "0" : "0 0 10px black",
      color: m ? "black" : "white"
    }
  }, g), d ? /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "0 0 auto",
      height: "2em",
      background: v.gray,
      display: "flex",
      alignItems: "center",
      fontWeight: "bold",
      padding: "0 0.5em"
    }
  }, "disabled") : null, /* @__PURE__ */ o.createElement(Q, {
    style: {
      padding: ".5em"
    }
  }, "" + u)) : null;
});
It.displayName = "QueryRow";
function Sr() {
}
const xr = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : Cr;
process.env.NODE_ENV;
const Ar = {
  origins: !0,
  priority: !0,
  timeout: 2e3,
  throttle: 1,
  limit: 2,
  // 동시에 최대 2개 URL만 prefetch
  ignores: [
    // API 엔드포인트 무시
    /\/api\//,
    // 파일 다운로드 무시
    /\.(zip|pdf|doc|docx|xls|xlsx|ppt|pptx)$/i,
    // noprefetch 속성이 있는 링크 무시
    (e, t) => (t == null ? void 0 : t.hasAttribute("noprefetch")) ?? !1,
    // 해시가 포함된 URL 무시 (SPA 라우팅)
    (e) => e.includes("#"),
    // 해당 2개 URL만 허용(그 외는 모두 무시)
    (e) => {
      try {
        const t = new URL(e, window.location.origin), n = `${t.origin}${t.pathname}`;
        return !(/* @__PURE__ */ new Set()).has(n);
      } catch {
        return !0;
      }
    }
  ]
};
function wr() {
  return Ar;
}
const Rr = Je({
  containerId: "MVM7ZHX",
  customScriptSrc: "https://www.inflearn.com/mvm7zhx/s.js"
}), Lr = Object.assign({}, Je({
  containerId: "58GKPFHR",
  dataLayerName: "commonDataLayer",
  customScriptSrc: "https://www.inflearn.com/58gkpfhr/s.js"
}), {
  name: "common"
}), Or = new Wt({
  defaultOptions: {
    queries: {
      retry: 0,
      suspense: !0,
      useErrorBoundary: !0,
      refetchOnWindowFocus: !1
    },
    mutations: {
      useErrorBoundary: !0
    }
  },
  logger: {
    log: console.log,
    error: console.log,
    warn: console.log
  }
});
function so({
  children: e,
  analytics: t,
  disableAnalyticsPlugins: n = !1,
  queryClient: r = Or,
  navigate: a = Mt,
  withNormalizeCSS: l = !0,
  quicklinkConfig: i = wr()
}) {
  const [s] = Vt(() => t || St({
    app: "inflearn-monolith",
    plugins: n ? [] : [Rr, Lr]
  })), u = t ?? s;
  return Ke(function() {
    (async () => {
      await Jt(i);
    })().catch((d) => {
      console.error("Failed to initialize quicklink:", d);
    });
  }, [i]), /* @__PURE__ */ w(Tt, { navigate: a, children: /* @__PURE__ */ w(Bt, { cdnLink: Ft, withNormalizeCSS: l, children: /* @__PURE__ */ pe(_t, { client: r, children: [
    /* @__PURE__ */ w(Ot, { styles: [Ht, Ut, process.env.NODE_ENV === "production" ? "" : ";label:AppShellProvider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9BcHBTaGVsbFByb3ZpZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwR2tCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9BcHBTaGVsbFByb3ZpZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBnb29nbGVUYWdNYW5hZ2VyIGZyb20gJ0BhbmFseXRpY3MvZ29vZ2xlLXRhZy1tYW5hZ2VyJztcbmltcG9ydCB7IEdsb2JhbCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB0eXBlIHsgQW5hbHl0aWNzSW5zdGFuY2UgfSBmcm9tICdAaW5mbGVhcm4vYW5hbHl0aWNzJztcbmltcG9ydCB7IEFuYWx5dGljc1Byb3ZpZGVyIH0gZnJvbSAnQGluZmxlYXJuL2FuYWx5dGljcyc7XG5pbXBvcnQgeyBUaGVtZVByb3ZpZGVyIH0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcbmltcG9ydCB7IFF1ZXJ5Q2xpZW50LCBRdWVyeUNsaWVudFByb3ZpZGVyIH0gZnJvbSAnQHRhbnN0YWNrL3JlYWN0LXF1ZXJ5JztcbmltcG9ydCB7IFJlYWN0UXVlcnlEZXZ0b29scyB9IGZyb20gJ0B0YW5zdGFjay9yZWFjdC1xdWVyeS1kZXZ0b29scyc7XG5pbXBvcnQgeyBBbmFseXRpY3MgfSBmcm9tICdhbmFseXRpY3MnO1xuaW1wb3J0IFJlYWN0LCB7IHVzZUVmZmVjdCwgdXNlU3RhdGUsIHR5cGUgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBDRE5fVVJMLCBNT0RFIH0gZnJvbSAnLi9hcHBDb25maWcnO1xuaW1wb3J0IHR5cGUgeyBSb3V0ZXJDb250ZXh0UHJvcHMgfSBmcm9tICcuL2NvbXBvbmVudHMvUm91dGVyL1JvdXRlclByb3ZpZGVyJztcbi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBpbXBvcnQvb3JkZXJcbmltcG9ydCB7IFJvdXRlclByb3ZpZGVyIH0gZnJvbSAnLi9jb21wb25lbnRzL1JvdXRlci9Sb3V0ZXJQcm92aWRlcic7XG5cbmltcG9ydCAnLi9pMThuL2NvbmZpZyc7XG5pbXBvcnQgeyBnZXRRdWlja2xpbmtDb25maWcgfSBmcm9tICcuL2NvbmZpZy9xdWlja2xpbmsuY29uZmlnJztcbmltcG9ydCB7IGdsb2JhbHMgfSBmcm9tICcuL3N0eWxlcyc7XG5pbXBvcnQgeyBzdHlsZVNrZWxldG9uIH0gZnJvbSAnLi9zdHlsZXMvc3R5bGVTa2VsZXRvbic7XG5pbXBvcnQgeyBuYXZpZ2F0ZVdpbmRvdyB9IGZyb20gJy4vdXRpbHMvbmF2aWdhdGVXaW5kb3cnO1xuaW1wb3J0IHsgaW5pdFF1aWNrbGluaywgdHlwZSBRdWlja2xpbmtDb25maWcgfSBmcm9tICcuL3V0aWxzL3F1aWNrbGluayc7XG5cbmNvbnN0IG9sZEFuYWx5dGljcyA9IGdvb2dsZVRhZ01hbmFnZXIoe1xuICBjb250YWluZXJJZDogJ01WTTdaSFgnLFxuICBjdXN0b21TY3JpcHRTcmM6ICdodHRwczovL3d3dy5pbmZsZWFybi5jb20vbXZtN3poeC9zLmpzJyxcbn0pO1xuXG5jb25zdCBuZXdBbmFseXRpY3MgPSBPYmplY3QuYXNzaWduKFxuICB7fSxcbiAgZ29vZ2xlVGFnTWFuYWdlcih7XG4gICAgY29udGFpbmVySWQ6ICc1OEdLUEZIUicsXG4gICAgZGF0YUxheWVyTmFtZTogJ2NvbW1vbkRhdGFMYXllcicsXG4gICAgY3VzdG9tU2NyaXB0U3JjOiAnaHR0cHM6Ly93d3cuaW5mbGVhcm4uY29tLzU4Z2twZmhyL3MuanMnLFxuICB9KSxcbiAge1xuICAgIG5hbWU6ICdjb21tb24nLFxuICB9XG4pO1xuXG5pbnRlcmZhY2UgQXBwUHJvdmlkZXJQcm9wcyB7XG4gIGNoaWxkcmVuOiBSZWFjdE5vZGU7XG4gIGFuYWx5dGljcz86IEFuYWx5dGljc0luc3RhbmNlO1xuICBkaXNhYmxlQW5hbHl0aWNzUGx1Z2lucz86IGJvb2xlYW47XG4gIHF1ZXJ5Q2xpZW50PzogUXVlcnlDbGllbnQ7XG4gIG5hdmlnYXRlPzogUm91dGVyQ29udGV4dFByb3BzWyduYXZpZ2F0ZSddO1xuICB3aXRoTm9ybWFsaXplQ1NTPzogYm9vbGVhbjsgLy8gVmFuaWxsYSBFeHRyYWN0IENTU+ulvCBvdmVycmlkZSDtlZjripQg66y47KCc66GcIOyduO2VtCDrtoTquLAg7LaU6rCAXG4gIHF1aWNrbGlua0NvbmZpZz86IFF1aWNrbGlua0NvbmZpZzsgLy8gUXVpY2tsaW5rIOyEpOyglSDsmLXshZhcbn1cblxuY29uc3QgX3F1ZXJ5Q2xpZW50ID0gbmV3IFF1ZXJ5Q2xpZW50KHtcbiAgZGVmYXVsdE9wdGlvbnM6IHtcbiAgICBxdWVyaWVzOiB7XG4gICAgICByZXRyeTogMCxcbiAgICAgIHN1c3BlbnNlOiB0cnVlLFxuICAgICAgdXNlRXJyb3JCb3VuZGFyeTogdHJ1ZSxcbiAgICAgIHJlZmV0Y2hPbldpbmRvd0ZvY3VzOiBmYWxzZSxcbiAgICB9LFxuICAgIG11dGF0aW9uczoge1xuICAgICAgdXNlRXJyb3JCb3VuZGFyeTogdHJ1ZSxcbiAgICB9LFxuICB9LFxuICBsb2dnZXI6IHtcbiAgICBsb2c6IGNvbnNvbGUubG9nLFxuICAgIGVycm9yOiBjb25zb2xlLmxvZyxcbiAgICB3YXJuOiBjb25zb2xlLmxvZyxcbiAgfSxcbn0pO1xuXG5mdW5jdGlvbiBBcHBTaGVsbFByb3ZpZGVyKHtcbiAgY2hpbGRyZW4sXG4gIGFuYWx5dGljcyxcbiAgZGlzYWJsZUFuYWx5dGljc1BsdWdpbnMgPSBmYWxzZSxcbiAgcXVlcnlDbGllbnQgPSBfcXVlcnlDbGllbnQsXG4gIG5hdmlnYXRlID0gbmF2aWdhdGVXaW5kb3csXG4gIHdpdGhOb3JtYWxpemVDU1MgPSB0cnVlLFxuICBxdWlja2xpbmtDb25maWcgPSBnZXRRdWlja2xpbmtDb25maWcoKSxcbn06IEFwcFByb3ZpZGVyUHJvcHMpIHtcbiAgY29uc3QgW2RlZmF1bHRBbmFseXRpY3NdID0gdXNlU3RhdGUoKCkgPT4ge1xuICAgIGlmIChhbmFseXRpY3MpIHtcbiAgICAgIHJldHVybiBhbmFseXRpY3M7XG4gICAgfVxuICAgIHJldHVybiBBbmFseXRpY3Moe1xuICAgICAgYXBwOiAnaW5mbGVhcm4tbW9ub2xpdGgnLFxuICAgICAgcGx1Z2luczogZGlzYWJsZUFuYWx5dGljc1BsdWdpbnMgPyBbXSA6IFtvbGRBbmFseXRpY3MsIG5ld0FuYWx5dGljc10sXG4gICAgfSk7XG4gIH0pO1xuXG4gIGNvbnN0IHJlc29sdmVkQW5hbHl0aWNzID0gYW5hbHl0aWNzID8/IGRlZmF1bHRBbmFseXRpY3M7XG5cbiAgdXNlRWZmZWN0KFxuICAgIGZ1bmN0aW9uIGluaXRpYWxpemVRdWlja2xpbmsoKSB7XG4gICAgICBjb25zdCBpbml0aWFsaXplUXVpY2tsaW5rID0gYXN5bmMgKCkgPT4ge1xuICAgICAgICBhd2FpdCBpbml0UXVpY2tsaW5rKHF1aWNrbGlua0NvbmZpZyk7XG4gICAgICB9O1xuXG4gICAgICBpbml0aWFsaXplUXVpY2tsaW5rKCkuY2F0Y2goKGVycm9yKSA9PiB7XG4gICAgICAgIGNvbnNvbGUuZXJyb3IoJ0ZhaWxlZCB0byBpbml0aWFsaXplIHF1aWNrbGluazonLCBlcnJvcik7XG4gICAgICB9KTtcbiAgICB9LFxuICAgIFtxdWlja2xpbmtDb25maWddXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8Um91dGVyUHJvdmlkZXIgbmF2aWdhdGU9e25hdmlnYXRlfT5cbiAgICAgIDxUaGVtZVByb3ZpZGVyIGNkbkxpbms9e0NETl9VUkx9IHdpdGhOb3JtYWxpemVDU1M9e3dpdGhOb3JtYWxpemVDU1N9PlxuICAgICAgICA8UXVlcnlDbGllbnRQcm92aWRlciBjbGllbnQ9e3F1ZXJ5Q2xpZW50fT5cbiAgICAgICAgICA8R2xvYmFsIHN0eWxlcz17W2dsb2JhbHMsIHN0eWxlU2tlbGV0b25dfSAvPlxuICAgICAgICAgIDxBbmFseXRpY3NQcm92aWRlciBhbmFseXRpY3M9e3Jlc29sdmVkQW5hbHl0aWNzfT57Y2hpbGRyZW59PC9BbmFseXRpY3NQcm92aWRlcj5cbiAgICAgICAgICB7TU9ERSAhPT0gJ3Byb2R1Y3Rpb24nICYmIDxSZWFjdFF1ZXJ5RGV2dG9vbHMgaW5pdGlhbElzT3Blbj17ZmFsc2V9IC8+fVxuICAgICAgICA8L1F1ZXJ5Q2xpZW50UHJvdmlkZXI+XG4gICAgICA8L1RoZW1lUHJvdmlkZXI+XG4gICAgPC9Sb3V0ZXJQcm92aWRlcj5cbiAgKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgQXBwU2hlbGxQcm92aWRlcjtcbiJdfQ== */"] }),
    /* @__PURE__ */ w(kt, { analytics: u, children: e }),
    $e !== "production" && /* @__PURE__ */ w(xr, { initialIsOpen: !1 })
  ] }) }) });
}
function kr({
  children: e
}) {
  const t = jt(Qt, {
    pollingIntervalMillis: 3e4,
    exposureEventDedupIntervalMillis: 1e3,
    autoOpenDevTool: $e !== "production",
    eventUrl: "https://gt.inflearn.com/hk-event",
    sdkUrl: "https://gt.inflearn.com/hk-sdk"
  }), n = Dt.get("deviceId"), r = n ? String(n) : void 0;
  return Ke(() => {
    !t || !r || t.setDeviceId(r);
  }, [r, t]), /* @__PURE__ */ w(Kt, { hackleClient: t, supportSSR: !0, children: e });
}
function Br({
  header: e,
  footer: t,
  children: n,
  disableBottomNavigation: r,
  isShowingLoginNeededNotification: a = !1,
  showChanneltalk: l = !1,
  showMoveTop: i = !1,
  isAntMan: s = !1
}) {
  const u = xt();
  return /* @__PURE__ */ pe(Pt, { isShowing: a ?? !1, children: [
    /* @__PURE__ */ w(At, {}),
    /* @__PURE__ */ pe(wt, { children: [
      i ? /* @__PURE__ */ w(qt, { isAntMan: s ?? !1 }) : null,
      u && /* @__PURE__ */ w(Rt, {}),
      /* @__PURE__ */ pe(Lt, { children: [
        e,
        /* @__PURE__ */ w("div", { id: zt.CHILDREN_WRAPPER, style: {
          backgroundColor: "white"
        }, children: n }),
        t && Nt(t, {
          hasBottomNavigation: !r
        }),
        /* @__PURE__ */ w(Yt, { children: r ? null : /* @__PURE__ */ w(tn, {}) }),
        l ? /* @__PURE__ */ w($t, {}) : null,
        /* @__PURE__ */ w(nn, {})
      ] })
    ] })
  ] });
}
function uo(e) {
  return /* @__PURE__ */ w(en, { children: /* @__PURE__ */ w(kr, { children: /* @__PURE__ */ w(Br, { ...e }) }) });
}
export {
  uo as AppShell,
  so as AppShellProvider,
  po as Header
};
